import { useStoreConfig } from '~/store/storeConfig'
import { useIdentity } from '~/store/identity'
import type { IClientInterface } from '~/types/auth/identityTypes'
import md5 from 'md5'
import pushToCriteoQueue from '~/utils/thirdPartyTrackers/Criteo/pushToCriteoQueue'

function getDeviceType(): string {
  return /iPad/.test(navigator.userAgent)
    ? 't'
    : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent)
    ? 'm'
    : 'd'
}

async function bindDataToWindowObject(criteoKey: string): Promise<void> {
  if (typeof window === 'undefined') {
    return
  }

  const user = await useIdentity().getUser()

  ;(window as any).deviceType = getDeviceType()
  ;(window as any).criteo_account = criteoKey
  ;(window as any).criteo_email = getCriteoEmail(user)

  if (user) {
    pushToCriteoQueue(
      { event: 'setAccount', account: (window as any).criteo_account }, // You should never update this line
      { event: 'setEmail', email: (window as any).criteo_email }, // Can be an empty string
      { event: 'setSiteType', type: (window as any).deviceType }
    )
  }
}

function getCriteoEmail(user: IClientInterface | null): string {
  if (!user) {
    return ''
  }

  return md5(user.email as string)
}

export default defineNuxtPlugin(async (_nuxtApp) => {
  const site = useStoreConfig().getSite

  const criteoKey = site?.criteo_key || null

  if (criteoKey) {
    useHead({
      script: [
        {
          src: `//static.criteo.net/js/ld/ld.js`,
          defer: true,
        },
      ],
    })

    await bindDataToWindowObject(criteoKey)
  }
})
